// 统一管理平台 SDK 动态加载器
// 来源: 统一管理平台api文档.txt 第 10 节（广告）、第 12 节（下载）
//
// APP_ID 由 worker /api/config 返回（公开值），避免构建期硬编码。
// SDK 脚本来自 unified-auth-admin，CORS 已开放，支持跨域加载。

const loaded = new Set<string>();

function injectScript(src: string, appId: string): Promise<void> {
  if (loaded.has(src)) return Promise.resolve();
  return new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.defer = true;
    s.dataset.appId = appId;
    s.onload = () => resolve();
    s.onerror = () => {
      // 加载失败不阻塞主流程
      console.warn('[sdk] 加载失败:', src);
      resolve();
    };
    document.head.appendChild(s);
    loaded.add(src);
  });
}

// 加载广告 + 下载 SDK（app 启动时调用一次）
export async function loadUnifiedSdk(appId: string, unifiedAuthBase: string): Promise<void> {
  if (!appId || !unifiedAuthBase) return;
  // unifiedAuthBase 形如 https://unified-auth-admin.pages.dev/api
  const base = unifiedAuthBase.replace(/\/api\/?$/, '');
  await Promise.all([
    injectScript(`${base}/sdk/ad-widget.js`, appId),
    injectScript(`${base}/sdk/download-widget.js`, appId),
  ]);
}
